export default {
    sysMenu: {
    emailManage: 'Marketing de Correo Electrónico',
    emailAutoPushConfig: 'Configuración de Correo Automático',
    bulkEmail: 'Correo Masivo',
    emailTemp: 'Gestión de Plantillas',
    emailSender: 'Gestión de Remitentes',
    emailLog: 'Registros de Envío',
    emailUnsubscribe: 'Lista de Desuscripción',
    emailSendRecordStats: 'Informe de Envío',
    seoPlatform: 'Plataforma SEO/GEO',
    seoPFDashboard: 'Panel',
    seoPFContentCenter: 'Centro de Contenidos',
    seoPFArticleManagement: 'Artículos',
    seoPFArticleType: 'Categorías',
    seoPFArticleTag: 'Etiquetas',
    seoPFManagerTools: 'Herramientas SEO/GEO',
    seoPFKeyWordCenter: 'Palabras Clave',
    seoPFAICreateContent: 'Generador IA',
    seoPFScore: 'Puntuador SEO/GEO',
    seoPFSiteConfig: 'Configuración del Sitio',
    seoPFPageModel: 'Plantillas SEO de Página',
    seoPFSiteLink: 'Enlaces Internos',
    seoPFSiteMapManagement: 'Mapa del Sitio',
    seoPFDeclDoc: 'Declaración del Sitio',
    seoPFHealthCheck: 'Verificación de Salud SEO',
    seoPFSiteBaseUrl: 'URL Base del Sitio',
    seoPFAuthor: 'Autores',
        sysAdsMgmt: 'Gestión de Atribución de Anuncios',
        silentMember: 'Lista de Usuarios Inactivos',
        adsmccaccount: "Configuración de Cuenta MCC de Anuncios",
        adsaccount: "Configuración de Atribución de Anuncios",
        adsreport: "Informe de Datos y Análisis",
        adsuserpushrecord: "Registros de Inserción",
        adsAgent: "Vinculación de Atribución de Agente",
        sys: "Sistema",
        memberList: "Lista de Miembros",
        sms: "Proveedor de Servicio SMS",
        agentCostStats: 'Costo del Agente',
        smsManage: "Gestión de SMS",
        bulkSMS: "SMS Masivo",
        modelSMS: "Plantillas de SMS",
        channelSMS: "Canales de Marketing de SMS",
        taskRegister: "Sin Depósito después del Registro",
        taskSilence: "Usuarios Inactivos",
        taskOff: "Usuarios Perdidos",
        welcomeSMS: "SMS de Bienvenida",
        restorageSMS: "Redepósito después del Primer Depósito",
        birthdaySMS: "Recordatorio de Cumpleaños",
        taskVIP: "Tareas VIP",
        smsRecordStats: "Informes de SMS",
        smsSendRecord: "Registros de SMS",
        agentDailyStats: 'Estadísticas de Desempeño Diario del Agente',
        risk: "Control de Riesgos",
        memberRiskDimensionStats: "Advertencia de Riesgo Multidimensional",
    ipRiskDimensionStats: "Advertencia de Usuario con Misma IP",
    deviceRiskDimensionStats: "Advertencia de Usuario con Mismo Dispositivo",
    bankRiskDimensionStats: "Advertencia de Usuario con Misma Tarjeta Bancaria",
    walletRiskDimensionStats: "Advertencia de Usuario con Misma Cartera",
        agentDailyPerformance: "Datos del Agente de Hoy",
        financial: "Finanzas",
        member: "Miembro",
        operation: "Operación",
        operationsGroup: "Centro de Operaciones",
        operationsBackgroundImage: "Gestión de Imagen de Fondo",
        systemConfig: "Menú",
        inactiveDepositors: 'Lista de Registrados pero no Depositados',
        memberChurn: "Lista de Abandono de Miembros",
        sysConfigMgmt: "Configuración del Sistema",
        // New menu categories
        userSecuritySettings: "Configuración de Usuario y Seguridad",
        loginRegisterConfig: "Configuración de Acceso y Registro",
        thirdPartyLoginConfig: "Configuración de Acceso de Terceros",
        appChannelMgmt: "Gestión de Aplicación y Canal",
        appMgmt: "Gestión de Aplicación",
        customerService: "Servicio al Cliente y Comunicación",
        livechatConfig: "Configuración de Chat en Vivo",
        memberVipSettings: "Miembro y Puntos/VIP",
        pointRuleConfig: "Configuración de Reglas de Puntos",
        vipConfig: "Configuración VIP",
        kycSecurity: "Cumplimiento de KYC y Seguridad",
        backendGoogleVerify: "Verificación de Google de Backend",
        vapeSecurityMode: "Modo de Certificación de Seguridad de Vape",
        imageUrlConfig: "URL de Acceso a Imagen de Juego",
        payCallbackConfig: "Dominio de Devolución de Llamada de Pago",
        countryWhitelistConfig: "Lista Blanca de País de Frontend",
        rtpRangeConfig: "Rango de Visualización de RTP",
        tinyEditorConfig: "Token del Editor Tiny",
        AIModelConfig: 'Configuración del Modelo de IA',
        market: "Mercado",
        agentMgmt: "Agente",
        agentTransfer: "Transferencia de Agente",
        queryRole: "Rol",
        userMgmt: "Cuenta",
        ipWhitelist: "Lista de IP",
        operationLog: "Registro de Operación",
        lang: "Idioma",
        bounsReport: "Informe de Bonificación",
        agentBonusStats: "Informe de Bonificación del Agente",
        buttons: "Botones",
        menus: "Menús",
        curreny: "Moneda",
        userAccountMgmt: "Cuenta de Usuario",
        activity: "Promoción",
        freeSpinGrant: "Otorgamiento de Giros Gratis",
        gamePlatform: "Juegos",
        clientInfo: "Contenido",
        vip: "VIP",
        mall: "Centro Comercial de Puntos",
        agentTotalStats: "Estadísticas del Agente",
        gamePlatformMgmt: "Configuración de Juegos",
        gameBRoutePlatform: "Plataforma B-Route",
        gameListMgmt: "Subjuegos",
        gameEntryMgmt: "Página de Inicio",
        gamePromotMgmt: "Juegos Principales",
        gameHotMgmt: "Juegos Populares",
        gameRecMgmt: "Juegos Recomendados",
        gameTypeMgmt: "Tipos de Juegos",
        gameModuleMgmt: "Gestión de Módulo Cliente",
        desktopGameModuleMgmt: "Gestión de Módulo de Escritorio",
        activityWelfareMgmt: "Historial",
        activityManualSendMgmt: "Envío por Lotes",
    fsBatch: "Envío de Giros Gratis",
        activityMgmt: "Promoción",
        activityTypeMgmt: "Tipos de Promociones",
        activityOperateMgmt: "Gestión de Ofertas Especiales",
        activityRedPacket: "Lluvia de Sobres Rojos",
        activityRedPacketMgmt: "Gestión de Lluvia de Sobres Rojos",
        redPacketStats: "Estadísticas de Lluvia de Sobres Rojos",
        activityRedemptionCodeMgmt: "Gestión de Código de Canje",
        redemptionCodeMgmt: "Gestión de Código de Canje",
        indexBotMenu: "Menú Inferior",
        indexLtMenu: "Menú Izquierdo",
        indexBanner: "Banner",
        indexContactUs: "Contacto",
        indexSpopup: "Ventana Emergente",
        indexStartAdvertising: "Anuncios",
        betRecord: 'Registros de Apuestas',
        betRecordA: 'Registros de Apuestas',
        betRecordB: 'Registros de Apuestas - B',
        manualBalance: 'Registros de Ajuste de Miembro',
        manualBalanceHistory: 'Registro de Cambios de Cuota de Ajuste',
        memberWithdrawLimit: 'Límite Diario de Retiro por Jugador',
        payWithdrawConfig: "Depósito/Retiro",
        riskWithdrawConfig: "Configuración de Retiro/Riesgo",
        riskAuthWithdraw: "Revisión de Retiro",
        kyc: "KYC",
        kycApply: "Historial de KYC",
        kycCBOApply: "Registros de Verificación de KYC",
        kycSUP: "Historial Completo de KYC",
        blacklistQuery: "Consulta de Lista Negra",
        productStok: "Inventario",
        productSetting: "Productos",
        exchangeRecord: "Cambio",
        payMethod: "Pago",
        callBackWhiteList: "Lista de Devolución de Llamada",
        withdrawMethod: "Retiro",
        withdrawOrderList: "Órdenes de Retiro",
        payOrderList: "Órdenes de Depósito",
        paymentChannel: "Canal de Pago",
        withdrawType: "Tipo de Retiro",
        vipExchangeMgmt: "Reglas VIP",
        vipSetupMgmt: "Nivel VIP",
        vipLogMgmt: "Progreso de VIP",
        memberMgmt: "Miembros",
        memberDtail: "Detalle de Miembro",
        more: "Más",
        analysis: "Análisis",
        inviteFriend: "Invitar Amigos",
        inviteFriendReport: "Informe de Invitación de Amigos",
        gameCodeReoprt: "Informe de Subjuego",
        gameCodeReoprtB: "Informe de Subjuego - B",
        gamePlatReoprt: "Informe de Juego",
        gamePlatReoprtB: "Informe de Juego - B",
        betReport: "Informe de Apuestas",
        betReportA: "Informe de Apuestas",
        betReportB: "Informe de Apuestas - B",
        crossDayTransferSettlement: "Panel de Análisis de Liquidación de Transferencia entre Días",
        dashboardReport: "Panel",
        withdrawReport: "Informe de Retiro",
        payReport: "Informe de Depósito",
        payOrderStat: "Panel de Recarga",
        withdrawOrderStat: "Panel de Retiro",
        rechargeSettlementAnalysis: "Análisis de Depósito y Retiro",
        registrationConversion: "Informe de Registro y Conversión",
        userRegisterDistribution: "Panel de Registro de Usuario",
        activeUserDistribution: "Panel de Usuario Activo",
        onlineUserDistribution: "Panel de Usuario En Línea",
        valueStats: "Informe de Estadísticas de Valor",
        keepStats: "Informe de Retención de Depósito",
        betKeepStats: "Informe de Estadísticas de Retención de Apuestas",
        overviewStats: "Informe de Estadísticas General",
        userAnalysis: "Análisis de Usuario",
        webSiteConfig: "Parámetros del Sitio Web",
        emailconfig: "Configuración de Cuenta de Correo",
        emailsendtempconfig: "Gestión de Plantilla de Correo",
        seoPageManager: "Gestión de Página SEO",
        notifyManage: 'Gestión de Notificación de Aplicación',
        autoPushRecord: "Registro de Inserción Automática",
        autoPushConfig: "Configuración de Inserción Automática",
        autoPushStats: "Estadísticas de Inserción Automática",
        manualPushRecord: "Registro de Inserción Manual",
        agentTag: "Etiqueta de Agente",
        agentType: "Tipo de Agente",
        manualPushConfig: "Configuración de Inserción Manual",
        manualPushReport: "Informe de Inserción Manual",
        kycconfig: "configuración de kyc",
        riskWithdrawConfigGroup: "Configuración de Riesgo de Retiro",
        riskWithdrawConfigPhp: "Configuración de Moneda PHP",
        riskWithdrawConfigVnd: "Configuración de Moneda VND",
        riskWithdrawConfigCny: "Configuración de Moneda CNY",
        riskWithdrawConfigUsd: "Configuración de Moneda USD",
        riskWithdrawConfigMxn: "Configuración de Moneda MXN",
        paramConfigGroup: "Configuración de Parámetros",
        paramAccountAuth: "Cuenta y Autenticación",
        paramSecurityRisk: "Seguridad y Riesgo",
        paramThirdPartyService: "Servicios de Terceros",
        paramAppMgmt: "Gestión de Aplicación",
        paramBizRule: "Reglas de Negocio y Parámetros del Sistema",
        paramResourceDisplay: "Gestión de Recursos",
        paramReportConfig: "Configuración de Informes Regulatorios",
        paramRouteStrategy: "Estrategia de Ruta de Juego",
        messageNotify: "Mensajes y Notificaciones",
        payWithdrawConfigGroup: "Configuración de Depósito y Retiro",
        withdrawBaseConfig: "Configuración Base de Retiro",
        withdrawAccountBindConfig: "Vinculación de Cuenta de Retiro",
        kycConfigGroup: "Configuración de KYC",
        kycGlobalConfig: "Configuración Global de KYC",
        kycNormalScene: "Escenario KYC de Usuario Regular",
        kycAgentScene: "Escenario KYC de Agente",
        kycFailRule: "Reglas de Fallos de KYC",
        memberLoginLog: "Registro de Acceso de Miembro",
        memberLoginLogReport: "Información Básica",
        memberLoginLogSummary: "Resumen de Registro de Acceso de Miembro",
        luckySpin: "Gestión de Giros de Suerte",
        luckySpinTicketMgmt: "Configuración de Boletos de Giro",
        luckySpinGrantTicketLog: "Registro de Otorgamiento",
        luckySpinLog: "Registro de Giros",
        activeMember: "Lista de Miembros Activos",
        depositMemberList: "Lista de Miembros Depositados",
        vipMemberList: "Lista de Miembros VIP",
        inboxMessage: "Gestión de Bandeja de Entrada",
        sendInboxMessage: "Registro Manual de Mensajes de Bandeja",
        autoInboxMannulConfig: "Envío Manual de Mensaje de Bandeja",
        autoInboxMessageConfig: "Configuración de Mensaje Automático de Bandeja",
        autoInboxMessage: "Datos de Mensaje Automático de Bandeja",
        mannuInboxStats: "Estadísticas Manual de Bandeja",
        autoInboxStats: "Estadísticas Automática de Bandeja",
        auditReport: "Informe de Auditoría",
        auditSummary: "Informe de Resumen",
        auditGameType: "Informe de Tipo de Juego",
        auditBranchGameType: "Informe de Tipo de Juego de Rama",
        auditProvider: "Informe de Proveedor",
        auditProviderGameType: "Tipo de Juego de Proveedor",
        auditGameOrder: "Orden de Juego",
        auditPlayerCount: "Informe de Conteo de Jugadores",
        auditPlayerAggregator: "Agregador de Jugadores",
        auditCloseReportUser: "Usuarios de informes cerrados",
        closeReportUser: "Registro de Cambio de Ruta de Juego",
        newsManagement: "Gestión de Noticias",
        newsListMgmt: "Artículos de Noticias",
        newsCategoryMgmt: "Categorías de Noticias",
        newsTagMgmt: "Etiquetas de Noticias",
        newsInternalLinkMgmt: "Palabras Clave de Enlaces Internos",
        newsCategory: "Categorías de Noticias",
        newsTag: "Etiquetas de Noticias",
        newsArticle: "Artículos de Noticias",
        userLeaderboard: "Clasificación de Usuario",
        depositLeaderboard: "Tabla de Clasificación de Depósitos",
        withdrawLeaderboard: "Tabla de Clasificación de Retiros",
        promotionLeaderboard: "Tabla de Clasificación de Promoción",
        winLeaderboard: "Tabla de Clasificación de Ganancias",
        lossLeaderboard: "Tabla de Clasificación de Pérdidas",
        betLeaderboard: "Tabla de Clasificación de Apuestas",
        gameRanking: "Clasificación de Juegos",
        leaderboardActivity: "Actividad de Tabla de Clasificación",
        leaderboardActivityActivityList: "Lista de Actividades",
        leaderboardActivityBoardRecords: "Registros de Tabla",
        leaderboardActivityAwardRecords: "Registros de Premios",
        importLog: "Gestión de Registro de Importación",
        inviterList: "Lista de Invitar Amigos",
        negativeProfitMember: "Lista de Miembros de Ganancia Negativa",
        jeepneyUserList: "Consulta de Usuario de Fisión",
        tagMgmt: "Gestión de Etiquetas",
        manualTag: "Etiqueta Manual",
        autoTag: "Etiqueta Automática",
        chickActivity: "Actividad de Registro",
        chickActivityMgmt: "Configuración de Actividad",
        chickActivityReport: "Informe de Datos",
        chickActivityUserStats: "Consulta de Estado de Usuario",
        jeepneyActivity: "Actividad de Fisión",
        jeepneyActivityMgmt: "Configuración de Actividad de Fisión",
        jeepneyBlockRewardMgmt: "Configuración de Seguimiento y Recompensa",
        jeepneySettlementMgmt: "Configuración de Liquidación",
        jeepneyFunnelAnalysis: "Análisis de Embudo de Jeepney",
        treasureBox: "Caja de Tesoro",
        treasureBoxMgmt: "Caja de Tesoro",
        treasureBoxConfig: "Configuración de Caja",
        treasureBoxStats: "Estadísticas de Caja",
        treasureBoxRecords: "Registros de Distribución de Caja",
        treasureBoxRecord: "Registros de Distribución de Caja",
        rebateList: "Registros de Comisión",
        report: "Informes Financieros",
    },
    // Nombres de botones: la clave es el buttonCode neutral de idioma (platformButton.buttonCode).
    // Si falta la clave, la pantalla muestra el buttonName almacenado (botones creados por operadores).
    sysButton: {
        "accountInfo-BankCardStatus": "Detalle de Miembro - Información de Cuenta - Habilitar/Deshabilitar Tarjeta Bancaria",
        "accountInfo-BankCardUnbind": "Detalle de Miembro - Información de Cuenta - Vincular/Desvincular Tarjeta Bancaria",
        "accountInfo-FlowManualAdjust": "Detalle de Miembro - Información de Cuenta - Ajuste Manual de Volumen de Apuestas",
        "accountInfo-WalletManualAdjust": "Detalle de Miembro - Información de Cuenta - Ajuste Manual de Cartera",
        "accountInfo-WalletStatus": "Detalle de Miembro - Información de Cuenta - Habilitar/Deshabilitar Cartera",
        "accountInfo-WalletTakeBack": "Detalle de Miembro - Información de Cuenta - Recuperación de Cartera",
        "accountInfo-WalletUnbind": "Detalle de Miembro - Información de Cuenta - Vincular/Desvincular Cartera",
        "accountInfo-manualAdjustPoint": "Detalle de Miembro - Puntos de Cuenta - Ajuste Manual de Puntos",
        adminRiskUnLock: "Desbloqueo de Control de Riesgo de Retiro por Administrador",
        adminRiskView: "Búsqueda de Control de Riesgo de Retiro por Administrador",
        "batchDistribution-Participation": "Envío por Lotes - Cupón de Participación",
        "batchDistribution-cash": "Envío por Lotes - Efectivo",
        "batchDistribution-integral": "Envío por Lotes - Puntos",
        "chargeOrderManager-comfirmOrder": "Órdenes de Depósito - Confirmar Orden",
        "chargeOrderManager-export": "Órdenes de Depósito - Exportar",
        "exchangeRecord-export": "Registros de Cambio - Exportar",
        "manualBalance-export": "Exportar Registros de Ajuste de Miembro",
        "manualBalanceHistory-export": "Exportar",
        "memberInfo-AgentName": "Detalle de Miembro - Información Básica - Agente Superior",
        "memberInfo-Email": "Detalle de Miembro - Información Básica - Correo Electrónico",
        "memberInfo-Identity": "Detalle de Miembro - Información Básica - Información de Identidad",
        "memberInfo-Phone": "Detalle de Miembro - Información Básica - Número de Teléfono",
        "memberInfo-RegulatoryReportClose": "Detalle de Miembro - Desactivar Reporte de Datos",
        "memberInfo-RegulatoryReportTab": "Detalle de Miembro - Pestaña de Estado de Ruta de Juego",
        "memberInfo-Remark": "Detalle de Miembro - Información Básica - Observación",
        "memberInfo-ResetPassword": "Detalle de Miembro - Información Básica - Restablecer Contraseña de Acceso",
        "memberInfo-ResetWithdrawPassword": "Detalle de Miembro - Información Básica - Restablecer Contraseña de Retiro",
        "memberInfo-WithdrawLimit": "Detalle de Miembro - Información Básica - Límite de Retiro",
        "memberWithdrawLimit-edit": "Límite Diario de Retiro por Jugador - Editar",
        "memberInfo-RiskLevel": "Detalle de Miembro - Información Básica - Control de Riesgo",
        "memberInfo-UserTypeSetting": "Configuración de Tipo de Usuario",
        "memberInfo-View-Phone": "Detalle de Miembro - Información Básica - Ver Número de Teléfono",
        "memberInfo-export": "Exportar Datos de Miembro",
        "memberInfo-kyc-edit": "KYC de Retiro - Editar",
        "memberInfo-upload": "Cargar Datos de Miembro",
        "memberchurn-export": "Lista de Abandono de Miembros - Exportar",
        "memberchurn-query": "Lista de Abandono de Miembros - Consultar",
        "memberkycinfo-batchSetFail": "Historial de KYC - Marcar en Lote como Fallido",
        "memberkycinfo-batchSetSuccess": "Historial de KYC - Marcar en Lote como Exitoso",
        "memberkycinfo-docmentData": "Edición de Información KYC - Documento",
        "memberkycinfo-historicalData": "Historial de KYC - Datos Históricos",
        "memberkycinfo-idCard": "Historial de KYC - Documento de Identidad",
        "memberkycinfo-setFail": "Historial de KYC - Marcar como Fallido",
        "memberkycinfo-setSuccess": "Historial de KYC - Marcar como Exitoso",
        "membernorecharge-export": "Lista de Registrados pero no Depositados - Exportar",
        "membernorecharge-query": "Lista de Registrados pero no Depositados - Consultar",
        "newsArticle-add": "Artículos de Noticias - Añadir Artículo",
        "newsArticle-approve": "Artículos de Noticias - Aprobar",
        "newsArticle-delete": "Artículos de Noticias - Eliminar",
        "newsArticle-edit": "Artículos de Noticias - Editar",
        "newsArticle-reject": "Artículos de Noticias - Rechazar",
        "newsArticle-seo-edit": "Artículos de Noticias - Edición SEO",
        opUserAdjustQuota: "Gestión de Cuota",
        opUserDelete: "Eliminar",
        opUserDisable: "Deshabilitar",
        opUserEdit: "Editar",
        opUserModifyRole: "Modificar Rol",
        opUserResetGoogleAuth: "Restablecer Verificación de Google",
        opUserResetLoginPassword: "Restablecer Contraseña de Acceso",
        "email-log-export": "Registro de Envío de Correo - Exportar",
        "sms-log-export": "Registros de SMS - Exportar Lista de Fallos",
        "withdrawOrderList-adminUnLock": "Órdenes de Retiro - Desbloqueo por Administrador",
        "withdrawOrderList-confirmWithdrawal": "Órdenes de Retiro - Confirmar Pago",
        "withdrawOrderList-export": "Órdenes de Retiro - Exportar",
        "withdrawOrderList-refusedWithdrawal": "Órdenes de Retiro - Rechazar Retiro",
        "withdrawOrderList-reject": "Órdenes de Retiro - Rechazar",
        "withdrawOrderList-replaceWithdrawal": "Órdenes de Retiro - Pago por Terceros"
    },
    menu: {
        add: "Añadir",
        edit: "Editar",
        menu: "Menú",
        parentMenu: "Nodo de Menú Padre",
        selectParentMenu: "Seleccionar Nodo de Menú Padre",
        menuLevel: "Nivel de Menú",
        selectMenuLevel: "Por favor Seleccione Nivel de Menú",
        menuCode: "Código de Menú",
        menuName: "Nombre del Menú",
        isLeaf: "Es Nodo Hoja",
        yes: "Sí",
        no: "No",
        menuUrl: "Dirección URL del Backend",
        enterMenuUrl: "Por favor Ingrese Dirección URL del Backend",
        menuOrder: "Orden del Menú"
    },
    tagView: {
        closeCurrent: "Cerrar Actual",
        closeOthers: "Cerrar Otros",
        closeAll: "Cerrar Todo",
        home: "Inicio"
    },
    avatar: {
        AIModelConfig: 'Configuración del Modelo de IA',
        personalCenter: "Centro Personal",
        changePassword: "Cambiar Contraseña",
        logout: "Cerrar Sesión"
    },
}
